//@ts-nocheck
import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
  fetchLoyaltyHubRequest,
  fetchLoyaltyHubFailure,
  fetchLoyaltyHubSuccess,
  fetchRewardRlhFailure,
  fetchRewardRlhRequest,
  fetchRewardRlhSuccess,
  lhSsoLoginRequest,
  lhSsoLoginSuccess,
  lhSsoLoginFailure,
} from '../reducer/loyaltyHubslice';
import { getRlhStatus, getRlhRewardStatus, lhSsoLogin } from '../api';

// helper: normalize postal codes (remove spaces + uppercase)

const normalizePostal = (code: string): string =>
  (code || "").replace(/\s+/g, "").toUpperCase();
 type Range = { start: string; end: string };
 
// helper: check if a postal code is outside all excluded ranges

const isPostalAllowed = (postalCode: string, excludedRanges: Range[]): boolean => {
  const code = normalizePostal(postalCode);
  return !excludedRanges.some(({ start, end }) => {
    const startCode = normalizePostal(start);
    const endCode = normalizePostal(end);
    return code >= startCode && code <= endCode;
  });

};

interface rlhStatusAction {
  type: typeof fetchLoyaltyHubRequest.type;
  payload: { accountId: string; customerId: string };
}

interface rlhRewardStatusAction {
  type: typeof fetchRewardRlhRequest.type;
  payload: { accountId: string; customerId: string };
}
interface lhSsoLoginAction {
  type: typeof lhSsoLoginRequest.type;
  payload: { 
    accountId: string; 
    customerId: string; 
    productName: string;
    logouturl: string;
    firstName: string;
    lastName: string;
  };
}

export function* fetchRlhstatusSaga(
  action: rlhStatusAction
): Generator<any, void, unknown> {
  try {
    const contentfulData = yield select(
      (state: any) => state.contentful?.contentfulData
    );
    const { entries = {}, assets = {} } = contentfulData || {};
// assume ranges come from Contentful JSON
    // example: [{ start: "E1A0A1", end: "E1A0A5" }, { start: "M4W1A0", end: "M4W1A9" }]
    const excludedRanges: Range[] =
      entries?.rb_rewards?.webRewardsTiles?.postalCodesRange || [];
    const { accountId, customerId } = action.payload;
    const res: any = yield call(
      getRlhStatus,
      'fetchRlhStatus',
      accountId,
      customerId
    );
    const inputPostalCode = normalizePostal(res?.contact?.address?.postalCode);
    const isUserEligible = isPostalAllowed(inputPostalCode, excludedRanges);
    const updatedRes = {
      ...res,
      isUserEligible,
    };
    yield put(fetchLoyaltyHubSuccess(updatedRes));
  } catch (error: any) {
    yield put(fetchLoyaltyHubFailure(error));
  }
}

export function* fetchRlhRewardStatusSaga(
  action: rlhRewardStatusAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId } = action.payload;
    const res: any = yield call(
      getRlhRewardStatus,
      'fetchLhrewardStatus',
      accountId,
      customerId
    );
    yield put(fetchRewardRlhSuccess(res));
  } catch (error: any) {
    yield put(fetchRewardRlhFailure(error || 'Failed to load'));
  }
}

export function* lhSsoLoginRequestSaga(
  action: lhSsoLoginAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId, productName, logouturl, firstName, lastName } = action.payload;

    const ssoRes: any = yield call(
      lhSsoLogin,
      'lhSsoLogin',
      accountId,
      customerId,
      productName,
      logouturl,
      firstName,
      lastName
    );
    if (ssoRes?.code === '200') {
      yield put(lhSsoLoginSuccess(ssoRes));
    } else {
      yield put(lhSsoLoginFailure(ssoRes));
    }
  } catch (error: any) {
    yield put(lhSsoLoginFailure(error || 'Failed to load'));
  }
}

export function* watchLoyltyHubSagas(): Generator<any, void, unknown> {
  yield takeLatest(fetchLoyaltyHubRequest.type, fetchRlhstatusSaga);
  yield takeLatest(fetchRewardRlhRequest.type, fetchRlhRewardStatusSaga);
  yield takeLatest(lhSsoLoginRequest.type, lhSsoLoginRequestSaga);
}
